<template>
  <div class="quotation-detail-page">
    <BjDivider right-fixed>
      <span>{{ $t('QuotationCenter.Details') }}</span>
      <template #right>
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
      </template>
    </BjDivider>
    <div class="quotation-shell">
      <div class="summary-bar">
        <!-- 物流产品 -->
        <div class="summary-item summary-item--left">
          <span class="summary-label">{{ $t('QuotationCustomerLang.LogisticsProduct') }}:</span>
          <span class="summary-value">{{ productName }}</span>
        </div>
        <!-- 有效期 -->
        <div class="summary-item summary-item--right">
          <span class="summary-label">{{ $t('QuotationCenter.effectiveTime') }}:</span>
          <span class="summary-value">{{ effectiveTimeText }}</span>
        </div>
      </div>

      <div class="rate-card">
        <BjDivider>
          {{ $t('QuotationCenter.shippingFee') }}
          <template slot="right">
            <el-button type="primary" size="mini" plain @click="$router.push({ name: 'BusinessQuotationCustomerShippingCost', query: { id: detailsID } })">{{ $t('QuotationCenter.edit') }}</el-button>
            <el-button type="primary" size="mini" plain @click="onExport('freight')">{{ $t('QuotationCenter.export') }}</el-button>
            <el-button type="primary" size="mini" plain @click="$router.push({ name: 'BusinessQuotationCustomerTrialCalculation', query: { id: detailsID, productName } })">{{ $t('QuotationCenter.trialCalculation') }}</el-button>
          </template>
        </BjDivider>
        <el-table ref="freightTable" :data="freightData" stripe border :header-cell-style="$rowStyle.DEFAULT" class="rate-table" max-height="442px" :class="{ 'rate-table--ready': tablesReady }">
          <!-- 序号 -->
          <el-table-column type="index" :label="$t('QuotationCenter.serialNumber')" align="center" width="60" />
          <!-- 费用项 feeItem 0.运费 1.操作费 2.超长附加费 3.托盘费 4.滞期费 -->
          <el-table-column prop="feeItem" :label="$t('QuotationCenter.feeItem')" align="center" min-width="141">
            <template slot-scope="scope">
              <span>{{ $t(QUOTATION_FEE_ITEM.bjGet(scope.row.feeItem)) }}</span>
            </template>
          </el-table-column>
          <!-- 计算燃油 calcFuel 0.是 1.否 -->
          <el-table-column prop="calcFuel" :label="$t('QuotationCenter.calcFuel')" align="center">
            <template slot-scope="scope">
              <span>{{ $t(QUOTATION_CALC_FUEL.bjGet(scope.row.calcFuel)) }}</span>
            </template>
          </el-table-column>
          <!-- 分区 -->
          <el-table-column prop="zone" :label="$t('QuotationCenter.zone')" align="center" />
          <!-- 包裹类型 packageType 0.包裹、1.文件、2.袋装、3.托盘 -->
          <el-table-column prop="packageType" :label="$t('QuotationCenter.packageType')" align="center">
            <template slot-scope="scope">
              <span>{{ $t(QUOTATION_PACKAGE_TYPE.bjGet(scope.row.packageType)) }}</span>
            </template>
          </el-table-column>
          <!-- 起始量 -->
          <el-table-column prop="startWeight" :label="$t('QuotationCenter.start')" align="center" />
          <!-- 结束量 -->
          <el-table-column prop="endWeight" :label="$t('QuotationCenter.end')" align="center" />
          <!-- 计算方式 calcMethod 0.速查、1.直乘、2.增量 -->
          <el-table-column prop="calcMethod" :label="$t('QuotationCenter.calcMethod')" align="center" min-width="164">
            <template slot-scope="scope">
              <span>{{ $t(QUOTATION_CALC_METHOD.bjGet(scope.row.calcMethod)) }}</span>
            </template>
          </el-table-column>
          <!-- 进位单位 -->
          <el-table-column prop="unitWeight" :label="$t('QuotationCenter.components.roundingUnit')" align="center" />
          <!-- 单价 -->
          <el-table-column prop="unitPrice" :label="$t('QuotationCenter.components.unitPrice')" align="center">
            <template slot-scope="scope">
              <span>{{ $number2money(scope.row.unitPrice, 4) }}</span>
            </template>
          </el-table-column>
          <!-- 最低收费 -->
          <el-table-column prop="minimumCharge" :label="$t('QuotationCenter.components.minimumCharge')" align="center">
            <template slot-scope="scope">
              <span>{{ $number2money(scope.row.minimumCharge) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="rate-card">
        <BjDivider>
          {{ $t('QuotationCenter.otherFee') }}
          <template slot="right">
            <el-button type="primary" size="mini" plain @click="$router.push({ name: 'BusinessQuotationCustomerOtherCost', query: { id: detailsID } })">{{ $t('QuotationCenter.edit') }}</el-button>
            <el-button type="primary" size="mini" plain @click="onExport('otherFee')">{{ $t('QuotationCenter.export') }}</el-button>
          </template>
        </BjDivider>
        <el-table ref="otherFeeTable" :data="otherFeeData" stripe border :header-cell-style="$rowStyle.DEFAULT" class="rate-table" max-height="442px" :class="{ 'rate-table--ready': tablesReady }">
          <!-- 序号 -->
          <el-table-column type="index" :label="$t('QuotationCenter.serialNumber')" align="center" width="60" />
          <!-- 费用项 feeItem 0.运费 1.操作费 2.超长附加费 3.托盘费 4.滞期费 -->
          <el-table-column prop="feeItem" :label="$t('QuotationCenter.feeItem')" align="center" min-width="141">
            <template slot-scope="scope">
              <span>{{ $t(QUOTATION_FEE_ITEM.bjGet(scope.row.feeItem)) }}</span>
            </template>
          </el-table-column>
          <!-- 计算燃油 calcFuel 0.是 1.否 -->
          <el-table-column prop="calcFuel" :label="$t('QuotationCenter.calcFuel')" align="center">
            <template slot-scope="scope">
              <span>{{ $t(QUOTATION_CALC_FUEL.bjGet(scope.row.calcFuel)) }}</span>
            </template>
          </el-table-column>
          <!-- 分区 -->
          <el-table-column prop="zone" :label="$t('QuotationCenter.zone')" align="center" />
          <!-- 包裹类型 packageType 0.包裹、1.文件、2.袋装、3.托盘 -->
          <el-table-column prop="packageType" :label="$t('QuotationCenter.packageType')" align="center">
            <template slot-scope="scope">
              <span>{{ $t(QUOTATION_PACKAGE_TYPE.bjGet(scope.row.packageType)) }}</span>
            </template>
          </el-table-column>
          <!-- 起始量 -->
          <el-table-column prop="startWeight" :label="$t('QuotationCenter.start')" align="center" />
          <!-- 结束量 -->
          <el-table-column prop="endWeight" :label="$t('QuotationCenter.end')" align="center" />
          <!-- 计算方式 calcMethod 0.速查、1.直乘、2.增量 -->
          <el-table-column prop="calcMethod" :label="$t('QuotationCenter.calcMethod')" align="center" min-width="164">
            <template slot-scope="scope">
              <span>{{ $t(QUOTATION_CALC_METHOD.bjGet(scope.row.calcMethod)) }}</span>
            </template>
          </el-table-column>
          <!-- 进位单位 -->
          <el-table-column prop="unitWeight" :label="$t('QuotationCenter.components.roundingUnit')" align="center" />
          <!-- 单价 -->
          <el-table-column prop="unitPrice" :label="$t('QuotationCenter.components.unitPrice')" align="center">
            <template slot-scope="scope">
              <span>{{ $number2money(scope.row.unitPrice, 4) }}</span>
            </template>
          </el-table-column>
          <!-- 最低收费 -->
          <el-table-column prop="minimumCharge" :label="$t('QuotationCenter.components.minimumCharge')" align="center">
            <template slot-scope="scope">
              <span>{{ $number2money(scope.row.minimumCharge) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { logisticApi } from '@/api';
import { quotationTimeFilter } from '@/filters';
import { exportFile } from '@/utils/index';
import viewMiXin from '@/utils/view-mixin.js';
import {
  QUOTATION_PACKAGE_TYPE,
  QUOTATION_FEE_ITEM,
  QUOTATION_BILLING_TYPE,
  QUOTATION_CHARGE_UNIT,
  QUOTATION_CALC_METHOD,
  loadQuotationOptions,
} from '@/utils/quotationOptions';
import {
  QUOTATION_CALC_FUEL,
} from '@/utils/constants';

export default {
  name: 'BusinessQuotationCustomerDetails',
  mixins: [viewMiXin],
  data() {
    return {
      pageName: 'BusinessQuotationCustomerDetails',
      tablesReady: false,

      QUOTATION_PACKAGE_TYPE,
      QUOTATION_FEE_ITEM,
      QUOTATION_BILLING_TYPE,
      QUOTATION_CHARGE_UNIT,
      QUOTATION_CALC_FUEL,
      QUOTATION_CALC_METHOD,

      productName: '',
      StartTime: '',
      EndTime: '',
      freightData: [],
      otherFeeData: [],

      detailsID: '',
    };
  },
  computed: {
    // 有效期 时间格式过滤
    effectiveTimeText() {
      if (!this.StartTime && !this.EndTime) return '';
      return `${quotationTimeFilter(this.StartTime)} - ${quotationTimeFilter(this.EndTime)}`;
    },
  },
  created() {
    loadQuotationOptions();
    // 获取报价详情
    this.getQuotationDetails();
  },
  mounted() {
    // 处理表头抖动
    this.handleTableLayout();
    this.$eventHub.$on('refreshBusinessQuotationCustomerDetails', this.refreshQuotationDetails);
  },
  activated() {
    // 处理表头抖动
    this.handleTableLayout();
  },
  beforeDestroy() {
    this.$eventHub.$off('refreshBusinessQuotationCustomerDetails', this.refreshQuotationDetails);
  },
  methods: {
    // 返回列表页
    handleClose() {
      this.complete('BusinessQuotationCustomer');
    },
    // 过滤导出表格数据的选项值，获取对应的国际化文本
    getExportOptionLabel(options, value) {
      const langKey = options.bjGet(value);
      return langKey ? this.$t(langKey) : value;
    },
    // 导出表格数据 过滤导出数据
    getExportTableData(tableData) {
      return (tableData || []).map((row, index) => ({
        [this.$t('QuotationCenter.feeItem')]: this.getExportOptionLabel(QUOTATION_FEE_ITEM, row.feeItem),
        [this.$t('QuotationCenter.calcFuel')]: this.getExportOptionLabel(QUOTATION_CALC_FUEL, row.calcFuel),
        [this.$t('QuotationCenter.zone')]: row.zone,
        [this.$t('QuotationCenter.packageType')]: this.getExportOptionLabel(QUOTATION_PACKAGE_TYPE, row.packageType),
        [this.$t('QuotationCenter.start')]: row.startWeight,
        [this.$t('QuotationCenter.end')]: row.endWeight,
        [this.$t('QuotationCenter.calcMethod')]: this.getExportOptionLabel(QUOTATION_CALC_METHOD, row.calcMethod),
        [this.$t('QuotationCenter.components.roundingUnit')]: row.unitWeight,
        [this.$t('QuotationCenter.components.unitPrice')]: this.$number2money(row.unitPrice, 4),
        [this.$t('QuotationCenter.components.minimumCharge')]: this.$number2money(row.minimumCharge),
      }));
    },
    // 中英文前端导出
    onExport(type) {
      const isFreight = type === 'freight';
      const tableData = isFreight ? this.freightData : this.otherFeeData;
      if (!tableData.length) {
        this.$message.warning(this.$t('table.emptyText'));
        return;
      }
      const fileName = `${this.$t(isFreight ? 'QuotationCenter.shippingFee' : 'QuotationCenter.otherFee')}.csv`;
      exportFile(fileName, this.getExportTableData(tableData));
    },
    // 获取报价详情
    getQuotationDetails() {
      logisticApi.getSupplierLogisticsQuoteList({ id: this.$route.query.id }).then((res) => {
        if (res && res.detail && res.detail.id) {
          this.productName = res.detail.productName || '';
          this.StartTime = res.detail.startTime || '';
          this.EndTime = res.detail.endTime || '';
          this.freightData = res.feeTypeDetailList1 || [];
          this.otherFeeData = res.feeTypeDetailList2 || [];
          // 用于后续页面跳转，详情ID
          this.detailsID = res.detail.id || '';
        }
      });
    },
    refreshQuotationDetails() {
      this.getQuotationDetails();
      this.handleTableLayout();
    },
    // 处理表头抖动
    handleTableLayout() {
      this.tablesReady = false;
      this.$nextTick(() => {
        const requestFrame = window.requestAnimationFrame || (callback => window.setTimeout(callback, 16));
        requestFrame(() => {
          if (this.$refs.freightTable) {
            this.$refs.freightTable.doLayout();
          }
          if (this.$refs.otherFeeTable) {
            this.$refs.otherFeeTable.doLayout();
          }
          this.tablesReady = true;
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.quotation-detail-page {
  min-height: calc(100vh - 84px);
  padding: 0px 16px 16px 16px;
  background: #f5f7fa;
  color: #172033;
}

.quotation-shell {
  width: 100%;
  background: #f5f7fa;
}

.summary-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-height: 40px;
  padding: 12px 16px;
  margin-bottom: 16px;
  background: #ffffff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.summary-item {
  display: inline-flex;
  align-items: center;
  min-height: 38px;
  font-size: 13px;
}

.summary-item--left {
  flex: 3;
  justify-content: flex-start;
}

.summary-item--center {
  flex: 3;
  justify-content: center;
}

.summary-item--right {
  flex: 4;
  justify-content: flex-end;
}

.summary-label {
  margin-right: 8px;
  color: #253041;
  font-weight: 600;
}

.summary-value {
  color: #0f172a;
}

.rate-card {
  padding: 0 24px 16px;
  margin: 16px 0 0;
  background: #ffffff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.rate-table {
  width: 100%;
  visibility: hidden;
}

.rate-table--ready {
  visibility: visible;
}

::v-deep .rate-table .el-table__cell {
  padding: 8px 0;
  font-size: 13px;
}

@media (max-width: 900px) {
  .quotation-detail-page {
    padding: 12px;
  }

  .quotation-shell {
    padding: 12px;
  }

  .summary-bar {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
  }

  .summary-item {
    flex: none;
    width: 100%;
  }

  .rate-card {
    padding: 0 12px 12px;
  }

  .rate-table {
    width: 100%;
  }
}
</style>
